<template>
  <div class="appraise-form">
    <Form ref="newForm"
      v-if="formLoaded"
      :model="paper"
      label-position="left"
      :label-width="200">
      <table class="form-table">
        <thead>
          <tr>
            <th colspan="4" class="table-header">{{ this.paper.title }}</th>
          </tr>
        </thead>
        <tbody>
          <section v-for="(section,sectionId) in this.paper.sections" :key="sectionId">
            <section  v-if="section.isSelfAppraise">
              <tr class="section-header" v-if="section.isAttachment">
                <td colspan="4">
                  {{ section.title }}
                </td>
              </tr>
              <tr class="section-header" v-else-if="section.showTitle">
                <td colspan="4">
                  {{ section.title }} {{ section.totalScore ? `（总分值：${section.totalScore}）` : ''}}
                  <div class="section-score">{{ section.calculatedScore }}</div>
                </td>
              </tr>
              <tr class="table-row"
                v-for="(question,questionId) in section.questions" :key="questionId">
                <td width="60%">
                  <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                    v-if="[1].indexOf(question.type)>=0"
                    :rules="[{required:true,type:'number',message:'请填写',trigger:'blur'}]">
                    <InputNumber :disabled="question.disabled" :name="question.name" v-model="question.value" @on-change="calculateQuestion(question)" />
                    <FormItem label="" v-if="question.extInfo&&question.needExtInfo" class="padding0"
                      :rules="[{required:true,type:'number',message:'请选择',trigger:'blur'}]"
                      :prop="`sections[${sectionId}].questions[${questionId}].optionValue`"
                      style="display:inline-block;padding:4px 8px">
                      <Select style="width:200px;margin-top:-8px;" v-model="question.optionValue" filterable v-if="question.options && (question.options instanceof Array)" @on-change="calculateQuestion(question)">
                        <Option v-for="(opt,optIdx) in question.options" :key="optIdx" :value="opt.value">{{opt.label}}</Option>
                      </Select>
                    </FormItem>
                    <section class="inline-formitem"
                      v-if="question.extInfo&&question.needExtInput&&question.options.length">
                      <FormItem :label="opt.label" class="padding0"
                        v-for="(opt,optIdx) in question.options" :key="optIdx"
                        :rules="[{required:true,type:opt.type,message:'请输入',trigger:'blur'}]"
                        :prop="`sections[${sectionId}].questions[${questionId}].options[${optIdx}].value`"
                        style="display:inline-block;">
                        <InputNumber v-if="'number'===opt.type" v-model="opt.value" @on-change="calculateQuestion(question)" />
                        <Input v-else-if="'text'===opt.type" v-model="opt.value" style="width:200px" @on-change="calculateQuestion(question)" />
                      </FormItem>
                    </section>
                  </FormItem>
                  <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                    v-if="[0].indexOf(question.type)>=0"
                    :rules="[{required:true,message:'请填写',trigger:'blur'}]">
                    <Input :disabled="question.disabled" :name="question.name" v-model="question.value" @on-change="calculateQuestion(question)" />
                    <FormItem label="" v-if="question.extInfo&&question.needExtInfo" class="padding0"
                      :rules="[{required:true,type:'number',message:'请选择',trigger:'blur'}]"
                      :prop="`sections[${sectionId}].questions[${questionId}].optionValue`"
                      style="display:inline-block;padding:4px 8px">
                      <Select style="width:200px;margin-top:-8px;" v-model="question.optionValue" filterable v-if="question.options && (question.options instanceof Array)" @on-change="calculateQuestion(question)">
                        <Option v-for="(opt,optIdx) in question.options" :key="optIdx" :value="opt.value">{{opt.label}}</Option>
                      </Select>
                    </FormItem>
                    <section class="inline-formitem"
                      v-if="question.extInfo&&question.needExtInput&&question.options.length">
                      <FormItem :label="opt.label" class="padding0"
                        v-for="(opt,optIdx) in question.options" :key="optIdx"
                        :rules="[{required:true,type:opt.type,message:'请输入',trigger:'blur'}]"
                        :prop="`sections[${sectionId}].questions[${questionId}].options[${optIdx}].value`"
                        style="display:inline-block;">
                        <InputNumber v-if="'number'===opt.type" v-model="opt.value" @on-change="calculateQuestion(question)" />
                        <Input v-else-if="'text'===opt.type" v-model="question.optionValue" style="width:200px" @on-change="calculateQuestion(question)" />
                      </FormItem>
                    </section>
                  </FormItem>
                  <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                    v-if="[2].indexOf(question.type)>=0">
                    <i-switch :name="question.name" v-model="question.value" @on-change="calculateQuestion(question)" />
                    <FormItem label="" :prop="`sections[${sectionId}].questions[${questionId}].detail`"
                      :rules="[{required:true,message:'请填写',trigger:'blur'}]"  
                      v-if="question.needDetail&&question.value">
                      <Input type="textarea" v-model="question.detail" placeholder="详细情况" />
                    </FormItem>
                  </FormItem>
                  <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                    v-if="[3].indexOf(question.type)>=0">
                    <i-switch :name="question.name" v-model="question.value" @on-change="calculateQuestion(question)" />
                    <FormItem label="" :prop="`sections[${sectionId}].questions[${questionId}].detail`"
                      :rules="[{required:true,message:'请填写',trigger:'blur'}]"  
                      v-if="question.needDetail&&question.value">
                      <Input type="textarea" v-model="question.detail" placeholder="详细情况" />
                    </FormItem>
                  </FormItem>
                  <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                    v-if="[6].indexOf(question.type)>=0"
                    :rules="[{required:true,type:'number',message:'请填写',trigger:'blur'}]">
                    <Select v-model="question.value" filterable v-if="question.options && (question.options instanceof Array)" @on-change="calculateQuestion(question)">
                      <Option v-for="(opt,optIdx) in question.options" :key="optIdx" :value="opt.value">{{opt.label}}</Option>
                    </Select>
                  </FormItem>
                  <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                    v-if="[4].indexOf(question.type)>=0">
                    <div class="question-list-type">
                      <div class="question-list-item-list" v-if="question.value && (question.value instanceof Array)">
                        <div class="question-list-item"
                          v-for="(listItem, listItemIdx) in question.value"
                          :key="listItemIdx">
                          <FormItem style="flex:1" label="" :prop="`sections[${sectionId}].questions[${questionId}].value[${listItemIdx}].value`"
                            :rules="[{required:true,message:'请填写',trigger:'blur'}]">
                            <Input type="textarea" v-model="listItem.value" :placeholder="listItem.placeholder" />
                          </FormItem>
                          <Button icon="md-remove" size="small" shape="circle" type="error" ghost @click="removeListItem(listItem, question)" style="margin-left:5px"></Button>
                        </div>
                      </div>
                      <Button type="primary" ghost long icon="md-add"
                        @click="addListItem(question)">
                        增加{{ question.title }}</Button>
                    </div>
                  </FormItem>
                  <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].value`" class="form-item"
                    v-if="[7].indexOf(question.type)>=0">
                    <div class="question-list-type">
                      <div class="question-list-item-list" v-if="question.value && (question.value instanceof Array)">
                        <div class="question-list-item"
                          v-for="(listItem, listItemIdx) in question.value"
                          :key="listItemIdx">
                          <FormItem label="" :prop="`sections[${sectionId}].questions[${questionId}].value[${listItemIdx}].value`"
                            :rules="[{required:true,message:'请选择',trigger:'blur'}]">
                            <Select v-model="listItem.value" filterable style="width:100px"
                              v-if="question.options && (question.options instanceof Array)"
                              @on-change="calculateQuestion(question)">
                              <Option v-for="(opt,optIdx) in question.options" :key="optIdx" :value="opt.value">{{opt.label}}</Option>
                            </Select>
                          </FormItem>
                          <FormItem style="flex:1" label="" :prop="`sections[${sectionId}].questions[${questionId}].value[${listItemIdx}].detail`"
                            :rules="[{required:true,message:'请填写',trigger:'blur'}]">
                            <Input type="textarea" v-model="listItem.detail" :placeholder="listItem.placeholder" />
                          </FormItem>
                          <Button icon="md-remove" size="small" shape="circle" type="error" ghost @click="removeListItem(listItem, question)" style="margin-left:5px"></Button>
                        </div>
                      </div>
                      <Button type="primary" ghost long icon="md-add"
                        @click="addListItem(question)">
                        增加{{ question.title }}</Button>
                    </div>
                  </FormItem>
                  <FormItem :label="question.title" :prop="`sections[${sectionId}].questions[${questionId}].url`" class="form-item"
                    v-if="[5].indexOf(question.type)>=0"
                    :rules="question.isRequired?[{required:true,validator:arrayValidator,trigger:'change'}]:null">
                    <Upload
                      ref="attachmentUploader"
                      :data="OSSParam"
                      :before-upload="(file)=>handleBeforeUpload(file, question)"
                      :multiple="question.options.multiple||false"
                      :max-size="question.options.sizeLimit||1024*10"
                      :on-success="(response, file, fileList)=>handleUploadSuccess(response, file, fileList, question)"
                      :format="getFormats(question.options.formats)"
                      :on-format-error="handleFormatError"
                      :on-exceeded-size="handleExceededSize"
                      :on-remove="removeItem"
                      :on-preview="previewUploaded"
                      :show-upload-list="false"
                      :action="uploadParams.host">
                      <Poptip trigger="hover" placement="bottom">
                        <Button @click="getOSSParams(questionId)"><Icon type="ios-cloud-upload-outline"></Icon>上传附件</Button>
                        <div slot="content">
                          <span class="small font-grey">格式要求:{{question.options.formats}}<br>文件大小限制: {{question.options.sizeLimit}}kb<br>多个文件: {{question.options.multiple}}</span>
                        </div>
                      </Poptip>
                    </Upload>
                    <div class="attachments">
                      <div class="attachment-thumb"
                        @click="previewImgUrl=item;showPreview=true"
                        :key="index"
                        v-for="(item,index) in question.url">
                        <img :src="item.url" v-if="item&&item.url&&item.type==='image'">
                        <span style="font-weight:bold;color:#999" v-if="item&&item.url&&item.type==='file'">{{item.surfix.toUpperCase()}}</span>
                        <div class="attachment-thumb-cover">
                          <Icon type="ios-eye-outline" @click.stop="previewImgUrl=item;showPreview=true"></Icon>
                          <Icon type="ios-trash-outline" @click.stop="removeItem(question, item, index)"></Icon>
                        </div>
                      </div>
                    </div>
                  </FormItem>
                </td>
                <td width="40%" class="item-extra-td">
                  <div class="description">
                    {{ question.description }}
                  </div>
                  <div class="score">
                    <div v-if="!section.isAttachment">本项得分：{{ question.calculatedScore || question.calculatedScore === 0 ? question.calculatedScore.toFixed(2) : '-' }}</div>
                  </div>
                </td>
              </tr>
            </section>
          </section>
        </tbody>
        <tfoot>
          <tr class="section-header">
            <td colspan="4">
              总分： {{ paper.calculatedScore || paper.calculatedScore === 0 ? paper.calculatedScore.toFixed(2) : '-'}}
            </td>
          </tr>
        </tfoot>
      </table>
    </Form>
    <Row :gutter="32" v-if="formLoaded">
      <i-col span="8">
        <Button type="info" size="large" long @click="calculate()">试算</Button>
      </i-col>
      <i-col span="8">
        <Button type="warning" size="large" long @click="draft">存草稿</Button>
      </i-col>
      <i-col span="8">
        <Button type="primary" size="large" long @click="submit">提交</Button>
      </i-col>
    </Row>
    <div class="full" v-if="!formLoaded">
      <Spin fix>加载中...</Spin>
    </div>
    <Modal v-model="showPreview" title="查看图片" @on-cancel="showPreview=false;previewImgUrl=null">
      <img :src="previewImgUrl" v-if="showPreview&&typeof(previewImgUrl)==='string'" style="width: 100%">
      <img :src="previewImgUrl.url" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='image'" style="width: 100%">
      <a :href="previewImgUrl.url" target="_blank" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='file'">查看</a>
    </Modal>
    <Modal v-model="showNoti" title="注意" @on-calcel="showNoti=false" @on-ok="showNoti=false">
      <p><b>自评流程：参与答题--试算打分--核对提交</b></p>
      <p><b>注意：提交后不可修改！</b></p>
    </Modal>
  </div>
</template>

<script>
import Api from '../../api/Api.js'
import * as math from 'mathjs'
export default {
  data () {
    return {
      loading: false,
      isSelf: true, // 是否是自评价，若是，则隐藏协会评价内容
      paper: {},
      formLoaded: false,
      isVeto: false, // 一票否决
      showNoti: false,
      uploadParams: {
        accessid: '',
        host: '',
        policy: '',
        signature: '',
        callbackbody: '',
        key: '',
        expire: 0
      },
      OSSParams: [],
      OSSParam: {
        name: '',
        key: '',
        policy: '',
        OSSAccessKeyId: '',
        success_action_status: '200',   // 让服务端返回200,不然，默认会返回204
        signature: '',
        fileIndex: 0
      },
      curOSSParamIndex: 0,
      previewImgUrl: null,
      showPreview: false,
      record: null,
      globalVars: {},
      tempValue: {}
    }
  },
  mounted () {
    this.initForm()
  },
  methods: {
    test (mt) {
      console.log(mt)
    },
    async getAppraisalRecordData () {
      if (this.$route.params.recordId) {
        this.formLoaded = false
        let record = await Api.Appraisal.getAppraisalRecord(this.$route.params.recordId)
          .catch(err => {
            this.$Notice.error({
              title: '获取记录失败!',
              desc: err.message
            })
            return false
          })
        // console.log(record)
        this.record = record
        if (record.status === 9 && record.rawJson) {
          // 处理草稿数据
          let paper = JSON.parse(record.rawJson)
          if (!paper.sections) {
            paper.sections = []
          }
          paper.sections.forEach(s => {
            s.questions.forEach(q => {
              // 记录全局变量
              if (q.scoreFormula) {
                let globalRefRegx = /\$[A-Za-z0-9]\w+\$/g
                let matches = Array.from(q.scoreFormula.matchAll(globalRefRegx))
                matches.forEach((match) => {
                  let variable = match[0]
                  let variableName = variable.substr(1, variable.length - 2)
                  let globalVar = this.globalVars[variableName]
                  if (!globalVar) {
                    this.globalVars[variableName] = [q.name]
                  } else {
                    globalVar.push(q.name)
                    this.globalVars[variableName] = Array.from(new Set(globalVar))
                  }
                })
              }
            })
          })
          let attachSection = paper.sections.find(o => o.isAttachment)
          if (attachSection) {
            if (!attachSection.questions) {
              attachSection.questions = []
            }
            attachSection.questions.forEach((q) => {
              if (q.ossKeys) {
                q.filePath = ''
                q.url = []
                q.ossKeys.forEach((o) => {
                  this.$nextTick(() => {
                    let key = o.indexOf('oss:') === 0 ? o.substr(4) : o
                    this.procOssKey(key).then(url => {
                      url.status = 'finished'
                      q.url.push(url)
                    })
                  })
                })
                q.filePath = q.ossKeys.join(',')
              }
            })
          }
          this.paper = paper
          this.formLoaded = true
          return Promise.resolve()
        } else if (record.status === 0 && record.paperId) {
          let paper = await Api.Appraisal.getAppraisalPaper(record.paperId)
            .catch(err => {
              this.$Notice.error({
                title: '获取记录失败!',
                desc: err.message
              })
              return false
            })
          // console.log(paper)
          paper.sections.forEach(s => {
            if (!s.calculatedScore) {
              s.calculatedScore = 0
            }
            s.questions.forEach(q => {
              if (q.type === 0) {
                if (q.defaultValue && q.defaultValue.indexOf('=') === 0) {
                  q.value = null
                } else {
                  q.value = q.defaultValue || null
                }
                if (q.extInfo) {
                  try {
                    let options = JSON.parse(q.extInfo)
                    q.options = options
                    if (options instanceof Array) {
                      q.needExtInfo = true
                      q.optionValue = null
                    } else if (options.label) {
                      q.needExtInput = true
                      q.optionValue = options.defaultValue
                    }
                  } catch (err) {
                    console.log(err)
                    q.options = []
                    q.optionValue = null
                  }
                }
              } else if (q.type === 1) {
                try {
                  if (q.defaultValue && q.defaultValue.indexOf('=') === 0) {
                    q.value = 0
                    q.disabled = true
                  } else {
                    q.value = parseFloat(q.defaultValue)
                  }
                } catch (err) {
                  console.log(err)
                  q.value = 0
                }
                if (q.extInfo) {
                  try {
                    let options = JSON.parse(q.extInfo)
                    q.options = options
                    if ((options instanceof Array) && options.length) {
                      if (options[0].type) {
                        q.needExtInput = true
                        q.optionValue = null
                      } else {
                        q.needExtInfo = true
                        q.optionValue = null
                      }
                    }
                  } catch (err) {
                    console.log(err)
                    q.options = []
                    q.optionValue = null
                  }
                }
              } else if (q.type === 2) {
                try {
                  q.value = Boolean(q.defaultValue)
                } catch (err) {
                  console.log(err)
                  q.value = false
                }
              } else if (q.type === 3) {
                try {
                  q.value = Boolean(q.defaultValue)
                } catch (err) {
                  console.log(err)
                  q.value = false
                }
              } else if (q.type === 4) {
                q.value = []
              } else if (q.type === 5) {
                if (q.extInfo) {
                  try {
                    let options = JSON.parse(q.extInfo)
                    q.options = options
                  } catch (err) {
                    console.log(err)
                    q.options = {
                      formats: 'pdf,jpg,jpeg,png',
                      sizeLimit: 10 * 1024,
                      multiple: true
                    }
                  }
                } else {
                  q.options = {
                    formats: 'pdf,jpg,jpeg,png',
                    sizeLimit: 10 * 1024,
                    multiple: true
                  }
                }
                q.value= null
              } else if (q.type === 6) {
                if (q.extInfo) {
                  try {
                    let options = JSON.parse(q.extInfo)
                    q.options = options
                  } catch (err) {
                    console.log(err)
                    q.options = []
                  }
                }
                try {
                  q.value = parseFloat(q.defaultValue)
                } catch (err) {
                  console.log(err)
                  q.value = 0
                }
              } else if (q.type === 7) {
                q.value = []
                if (q.extInfo) {
                  try {
                    let options = JSON.parse(q.extInfo)
                    q.options = options
                  } catch (err) {
                    console.log(err)
                    q.options = []
                  }
                }
              } else {
                q.value = null
              }
              if (!q.calculatedScore) {
                q.filePath = null
                q.ossKeys = []
                q.url = []
                q.calculatedScore = 0
              }
              // 记录全局变量
              if (q.scoreFormula) {
                let globalRefRegx = /\$[A-Za-z0-9]\w+\$/g
                let matches = Array.from(q.scoreFormula.matchAll(globalRefRegx))
                matches.forEach((match) => {
                  let variable = match[0]
                  let variableName = variable.substr(1, variable.length - 2)
                  let globalVar = this.globalVars[variableName]
                  if (!globalVar) {
                    this.globalVars[variableName] = [q.name]
                  } else {
                    globalVar.push(q.name)
                    this.globalVars[variableName] = Array.from(new Set(globalVar))
                  }
                })
              }
            })
          })
          this.paper = paper
          console.log(paper)
          this.formLoaded = true
          return Promise.resolve()
        } else {
          this.$Modal.error({
            title: '发生错误',
            content: '当前状态不允许答题',
            onOk: () => {
              this.$router.push('/guarantor-appraisal/list-record')
            }
          })
          this.formLoaded = false
        }
      }
    },
    async initForm () {
      await this.getAppraisalRecordData()
      // this.formLoaded = true
      this.showNoti = true
    },
    getConfig (key) {
      return this.$store.getters.sysConfigs[key]
    },
    arrayValidator (rule, value, callback) {
      if (!value || !(value instanceof Array) || !value.length) {
        callback(new Error('没有元素'))
      } else {
        callback()
      }
    },
    getFormats (fmtStr) {
      if (!fmtStr) {
        return ['pdf', 'jpg', 'jpeg', 'png', 'doc', 'docx', 'xls', 'xlsx']
      }
      let arr = fmtStr.split(',')
      let result = arr.map((a) => {
        return a.trim()
      })
      return result
    },
    getOSSParams (index) {
      this.$Api.Guarantor.getUploadParams('appraise').then((res) => {
        console.log(res)
        this.uploadParams = {
          accessid: res.accessid,
          host: res.host,
          policy: res.policy,
          signature: res.signature,
          callbackbody: res.callbackbody,
          key: res.dir,
          expire: res.expire
        }
        this.uploadParams.host = this.uploadParams.host.replace('-internal', '')
        this.curOSSParamIndex = index    // 上传控件序号
      }).catch(err => {
        this.$Message.error(err.message)
      })
    },
    handleBeforeUpload (file, question) {
      console.log(file, question)
      let filename = this.uploadParams.key + this.randomString(10) + this.getSuffix(file.name)
      this.OSSParams[this.curOSSParamIndex] = {
        name: file.name,
        key: filename,
        questionId: question.tid,
        policy: this.uploadParams.policy,
        OSSAccessKeyId: this.uploadParams.accessid,
        success_action_status: '200',   // 让服务端返回200,不然，默认会返回204
        signature: this.uploadParams.signature,
        fileIndex: this.curOSSParamIndex
      }
      this.OSSParam.name = file.name
      this.OSSParam.key = filename
      this.OSSParam.policy = this.uploadParams.policy
      this.OSSParam.OSSAccessKeyId = this.uploadParams.accessid
      this.OSSParam.success_action_status = '200'   // 让服务端返回200,不然，默认会返回204
      this.OSSParam.signature = this.uploadParams.signature
      this.OSSParam.fileIndex = this.curOSSParamIndex
      console.log(this.OSSParams, file)
    },
    async handleUploadSuccess (response, file, fileList, questionItem) {
      let ossParam = this.OSSParams.find(o => o && o.questionId === questionItem.tid)
      console.log(ossParam, file, fileList, questionItem)
      if (!ossParam) {
        return false
      }
      let index = ossParam.fileIndex
      let attachSection = this.paper.sections.find(o => o.isAttachment)
      let attach = attachSection.questions[index]
      if (fileList.length > attach.fileCountLimit) {
        fileList.splice(0, 1)
        attach.ossKeys.splice(0, 1)
      }
      if (!attach.ossKeys) {
        attach.ossKeys = []
      }
      if (!attach.url) {
        attach.url = []
      }
      let filename = 'oss:' + ossParam.key
      file.name = filename
      this.$nextTick(async () => {
        await this.procOssKey(filename).then(url => {
          url.status = 'finished'
          attach.url.push(url)
        })
        attach.ossKeys.push(filename)
        attach.filePath = attach.ossKeys.join(',')
        console.log(attachSection)
      })
    },
    removeItem (question, item, attachIdx) {
      let attach = question
      attach.url.splice(attachIdx, 1)
      let keys = attach.filePath.split(',')
      keys.splice(attachIdx, 1)
      attach.ossKeys = keys
      keys = keys.join(',')
      console.log(keys)
      attach.filePath = keys
    },
    // removeItem (item, attachIdx) {
    //   let attachSection = this.paper.sections.find(o => o.isAttachment)
    //   let attach = attachSection.questions[attachIdx]
    //   let idx = attach.url.findIndex(o => o.name === item.name)
    //   attach.url.splice(idx, 1)
    //   let keys = attach.filePath.split(',')
    //   keys.splice(idx, 1)
    //   keys = keys.join(',')
    //   console.log(keys)
    //   attach[attachIdx].ossKeys = keys
    //   attach[attachIdx].filePath = keys
    // },
    previewUploaded (file) {
      let key = file.name.indexOf('oss:') === 0 ? file.name.substr(4) : file.name
      this.procOssKey(key).then((obj) => {
        console.log(obj)
        this.previewImgUrl = obj.url
        this.showPreview = true
      })
    },
    async procOssKey (k) {
      let url = await this.procOSSUrl(k)
      return new Promise((resolve) => {
        let surfix = url.substr(url.lastIndexOf('.') + 1).toLowerCase()
        if (surfix.indexOf('?')) {
          surfix = surfix.substring(0, surfix.indexOf('?'))
        }
        let type = 'image'
        switch (surfix) {
          case 'jpg':
            type = 'image'
            break
          case 'jpeg':
            type = 'image'
            break
          case 'png':
            type = 'image'
            break
          case 'gif':
            type = 'image'
            break
          case 'pdf':
            type = 'file'
            break
          case 'doc':
            type = 'file'
            break
          case 'docx':
            type = 'file'
            break
          case 'xls':
            type = 'file'
            break
          case 'xlsx':
            type = 'file'
            break
          case 'ppt':
            type = 'file'
            break
          case 'pptx':
            type = 'file'
            break
          default:
            type = 'file'
            break
        }
        resolve({
          name: k,
          url,
          type,
          surfix
        })
      })
    },
    procOSSUrl (_key) {
      return new Promise((resolve, reject) => {
        let url = ''
        let ossKey = window.encodeURIComponent(window.btoa(_key))
        Api.Guarantee.getOssUrl(ossKey).then((res) => {
          // console.log(typeof(res), res)
          url = res
          resolve(url)
        }).catch(err => {
          this.$Message.error('获取文件地址失败!' + err.message)
          reject(err)
        })
      })
    },
    handleFormatError () {
      this.$Notice.warning({
        title: '文件格式不正确',
        desc: '上传文件格式不正确。'
      })
    },
    handleExceededSize () {
      this.$Notice.warning({
        title: '文件大小超出限制',
        desc: '上传文件大小超出限制范围。'
      })
    },
    randomString (len) {
      len = len || 32
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      var maxPos = chars.length
      var pwd = ''
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return pwd
    },
    getSuffix (filename) {
      let pos = filename.lastIndexOf('.')
      let suffix = ''
      if (pos !== -1) {
        suffix = filename.substring(pos)
      }
      return suffix
    },
    addListItem (question) {
      if (question.value && question.value instanceof Array) {
        question.value.push({
          placeholder: `填写${question.title}事由`,
          value: '',
          required: true
        })
      } else {
        question.value = [{
          placeholder: `填写${question.title}事由`,
          value: '',
          required: true
        }]
      }
      this.calculate(question.name)
    },
    removeListItem (item, question) {
      let itemIdx = question.value.findIndex(o => o === item)
      question.value.splice(itemIdx, 1)
      this.calculate(question.name)
    },
    calculate (name) {
      if (name) {
        let section = this.paper.sections.find(o => o.name === name)
        if (section) {
          if (section.isSelfAppraise) {
            if (section.isAttachment) {
              return 0
            }
            let questions = section.questions
            questions.forEach((question) => {
              this.calculateQuestion(question)
            })
            this.calculateSection(section)
          }
        } else {
          let questionItem, sectionItem
          this.paper.sections.forEach((sec) => {
            if (sec.questions && sec.questions instanceof Array) {
              sec.questions.forEach((q) => {
                if (q.name === name) {
                  questionItem = q
                  sectionItem = sec
                }
              })
            }
          })
          if (questionItem) {
            this.calculateQuestion(questionItem)
            this.calculateSection(sectionItem)
          }
        }
      } else {
        // 全部计算
        let accumulation = 0
        const parser = math.parser()
        this.paper.sections.forEach((sec) => {
          if (sec.isSelfAppraise) {
            if (sec.questions && sec.questions instanceof Array) {
              sec.questions.forEach((q) => {
                this.calculateQuestion(q)
              })
            }
            this.calculateSection(sec)
            if (!this.paper.scoreFormula) {
              accumulation += sec.calculatedScore
            } else {
              parser.evaluate(`${sec.name} = ${sec.calculatedScore}`)
            }
          }
        })
        if (this.isVeto) {
          console.log('veto')
          this.paper.calculatedScore = -999
          return -999
        }
        if (this.paper.scoreFormula) {
          let result = parser.evaluate(this.paper.scoreFormula)
          accumulation = Math.round(result * 100) / 100
        }
        this.paper.calculatedScore = accumulation
        console.log(this.paper.calculatedScore)
      }
    },
    calculateQuestion (questionItem) {
      if (questionItem.type === 5) {
        questionItem.calculatedScore = 0
        return 0
      }
      if (questionItem.type === 3 && questionItem.value) {
        this.isVeto = true
        questionItem.calculatedScore = -999
        return -999
      }
      if (!questionItem.scoreFormula) {
        questionItem.calculatedScore = questionItem.value
        return questionItem.value
      }
      let dic = {
        VALUE: questionItem.value
      }
      this.tempValue[questionItem.name] = questionItem.value
      if (questionItem.type === 4) {
        dic = {
          COUNT: questionItem.value.length
        }
      }
      if (questionItem.type === 7) {
        dic = {}
        dic['DISTINCT_CAT_COUNT'] = 0
        try {
          let options = JSON.parse(questionItem.extInfo)
          options.forEach((opt) => {
            let ct = questionItem.value.filter((item) => {return item.value == opt.value}).length
            dic['COUNT_' + opt.value] = ct
            if (ct) {
              dic['DISTINCT_CAT_COUNT'] += 1
            }
          })
        } catch (err) {
          console.log(err)
        }
      } else if ([0, 1].indexOf(questionItem.type) >= 0) {
        if (questionItem.extInfo) {
          if (questionItem.optionValue !== null && questionItem.optionValue !== undefined) {
            dic['OPTION_VALUE'] = questionItem.optionValue
          }
          if (questionItem.needExtInput) {
            questionItem.options.forEach((opt, optIdx) => {
              dic[`OPTION_VALUE${optIdx}`] = opt.value || 0
            })
          }
        }
      }
      const parser = math.parser()
      const questionValueParser = math.parser()
      for (let key in dic) {
        if (dic[key] !== null && dic[key] !== undefined) {
          parser.evaluate(`${key} = ${dic[key]}`)
          questionValueParser.evaluate(`${key} = ${dic[key]}`)
        }
      }
      if (questionItem.scoreFormula) {
        let globalRefRegx = /\$[A-Za-z0-9]\w+\$/g
        let matches = Array.from(questionItem.scoreFormula.matchAll(globalRefRegx))
        // console.log(questionItem.name, questionItem.scoreFormula, matches)
        matches.forEach((match) => {
          // console.log(match)
          let variable = match[0]
          let variableName = variable.substr(1, variable.length - 2)
          let variableQuestion = this.getQuestionByName(variableName)
          // console.log(`${variable} = ${variableQuestion.value}`)
          parser.evaluate(`${variable} = ${variableQuestion.value}`)
          questionValueParser.evaluate(`${variable} = ${variableQuestion.value}`)
        })
      }
      
      if (questionItem.defaultValue && questionItem.defaultValue.indexOf('=') === 0) {
        // 动态计算值
        let valueFormula = questionItem.defaultValue.substr(1)
        // console.log(valueFormula)
        let questionValue = questionValueParser.evaluate(valueFormula)
        questionItem.value = questionValue
      }
      // console.log(dic, questionItem.scoreFormula)
      let result = parser.evaluate(questionItem.scoreFormula)
      questionItem.calculatedScore = result
      // 通知引用方更新
      let globalVar = this.globalVars[questionItem.name]
      if (globalVar) {
        globalVar.forEach((g) => {
          this.calculate(g)
        })
      }
      return result
    },
    getQuestionByName (questionName) {
      let question = null
      this.paper.sections.forEach(s => {
        s.questions.forEach((q) => {
          if (q.name === questionName) {
            question = q
          }
        })
      })
      return question
    },
    calculateSection (sectionItem) {
      if (sectionItem.isSelfAppraise) {
        if (sectionItem.isAttachment) {
          sectionItem.calculatedScore = 0
          return 0
        }
        let sum = 0
        let questions = sectionItem.questions
        questions.forEach((q) => {
          sum += q.calculatedScore
        })
        if (!sectionItem.scoreFormula) {
          sectionItem.calculatedScore = 0
          questions.forEach((q) => {
            if (q.type === 3 && q.value) {
              sectionItem.calculatedScore = -999
              return -999
            }
            sectionItem.calculatedScore += q.calculatedScore
            sum += q.calculatedScore
          })
          return sectionItem.calculatedScore
        }
        const parser = math.parser()
        parser.evaluate(`SUM = ${sum}`)
        questions.forEach((q) => {
          // console.log(`${q.name} = ${q.calculatedScore}`)
          parser.evaluate(`${q.name} = ${q.calculatedScore}`)
        })
        let result = parser.evaluate(sectionItem.scoreFormula)
        sectionItem.calculatedScore = result
        return result
      } else {
        return 0
      }
    },
    submit () {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认提交自评表么？（提交后不可修改）</p>',
        onOk: () => {
          this.$refs.newForm.validate((valid) => {
            console.log(valid)
            if (valid) {
              this.loading = true
              this.$Spin.show()
              this.calculate()
              Api.Appraisal.submitAppraisalPaper({
                id: this.record.tid,
                isDraft: false,
                calculatedScore: this.paper.calculatedScore,
                rawJson: JSON.stringify(this.paper)
              }).then(() => {
                this.loading = false
                this.$Spin.hide()
                setTimeout(() => {
                  this.submitSuccess()
                }, 1000)
                this.$Notice.success({
                  title: '提交成功!',
                  desc: '最终得分以审核结果为准。'
                })
              })
              .catch(err => {
                console.log('err', err)
                this.$Message.error('提交失败!' + err.message)
                this.loading = false
                this.$Spin.hide()
              })
            }
          })
        },
        onCancel: () => {
        }
      })
    },
    submitSuccess () {
      this.$Modal.success({
        title: '提交成功',
        content: '最终得分以审核结果为准。',
        onOk: () => {
          this.$router.push('/guarantor-appraisal/list-record')
        }
      })
    },
    draft () {
      this.loading = true
      this.$Spin.show()
      this.calculate()
      this.$nextTick(() => {
        Api.Appraisal.submitAppraisalPaper({
          id: this.record.tid,
          isDraft: true,
          calculatedScore: this.paper.calculatedScore,
          rawJson: JSON.stringify(this.paper)
        }).then(() => {
          this.$Message.success('保存成功!')
          this.loading = false
          this.$Spin.hide()
          this.$router.back()
        })
        .catch(err => {
          console.log('err', err)
          this.$Message.error('提交失败!' + err.message)
          this.loading = false
          this.$Spin.hide()
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.attachments {
  display: flex;
  flex-direction: row;
  margin: 10px 0;
  flex-wrap: wrap;
}
.attachment-thumb {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-color: #efefef;
  width: 100px;
  height: 100px;
  margin-right: 4px;
  transition: all .2s ease-in-out;
  cursor: pointer;
  padding: 3px;
  border: 1px solid #d2d2d2;
  position: relative;
  &:hover {
    border: 1px solid rgb(65,157,253);
    background-color: #fff;
  }
  overflow: hidden;
  img {
    width: 100%;
  }
  .attachment-thumb-cover{
    opacity: 0;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
    transition: all .3s linear;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  &:hover .attachment-thumb-cover{
    opacity: 1;
  }
  .attachment-thumb-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 5px;
  }
}
</style>